import { Link } from 'react-router-dom';
import './index.css';

export const Error = () => {
  return (
    <div className="error-page">
      <div className="error-card">
        <div className="error-eyebrow">404</div>
        <h2 className="error-title">Whoops, this page doesn&apos;t exist!</h2>
        <p className="error-subtitle">
          The link might be broken, or the page may have been moved.
        </p>

        <div className="error-actions">
          <Link className="error-link" to="/">
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};
